import React from "react";

const IDot = ({ color = "#D8D8D9", width = "4", height = "4", ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 4 4"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_1265_44310)">
        <path
          d="M3.375 2C3.375 1.24061 2.75939 0.625 2 0.625C1.24061 0.625 0.625 1.24061 0.625 2C0.625 2.75939 1.24061 3.375 2 3.375C2.75939 3.375 3.375 2.75939 3.375 2ZM3.625 2C3.625 2.89746 2.89746 3.625 2 3.625C1.10254 3.625 0.375 2.89746 0.375 2C0.375 1.10254 1.10254 0.375 2 0.375C2.89746 0.375 3.625 1.10254 3.625 2Z"
          fill={color}
        />
        <path
          d="M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5C2.82843 0.5 3.5 1.17157 3.5 2C3.5 2.82843 2.82843 3.5 2 3.5C1.17157 3.5 0.5 2.82843 0.5 2Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1265_44310">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IDot;
